export default __webpack_public_path__ + "static/media/DelegateAvatar.daa1a07d.svg";